import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import FeePlanStatusTable from "./FeePlanStatusTable";
import EndPoints from "../../Api/EndPoints";
import { formatDisplayDate } from "../../Components/Shared/FormDateInput/dateFormat";

const FeePlanStatusDashboard = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
  setNoTimeSet,
}) => {
  const [reportDashboardData, setReportDashboardData] = useState([]);
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("other");
  const [headers, setHeaders] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (dataClient) {
      fetchDashboardData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataClient]);

  const fetchDashboardData = async () => {
    setNoTimeSet(true);
    setIsLoading(true);
    setIsMessageBoxVisible(true);

    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span style={{ marginLeft: "10px", marginTop: "3px" }}>
            Loading data, please wait...
          </span>
        </div>
      </div>
    );

    setActiveImg(false);

    const slowLoadingTimer = setTimeout(() => {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span style={{ marginLeft: "10px", marginTop: "3px" }}>
              This is taking longer than usual, please wait a moment...
            </span>
          </div>
        </div>
      );
    }, 5000);

    try {
      const response = await fetch(`${EndPoints.GET_STUDENT_FEE_PLAN_DASHBOARD}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch student fee plan dashboard data.");
      }

      const result = await response.json();

      // API response:
      // result.data[0] = headers
      // result.data[1...] = rows
      const tableData = result?.data || [];

      const apiHeaders = tableData[0] || [];
      const rows = tableData.slice(1);

      // Remove n* / t* from headers
      const formattedHeaders = apiHeaders.map((header) =>
        typeof header === "string" ? header.substring(2) : header
      );

      const transformedRows = rows.map((row) =>
        row.map((cell, index) => {
          // Admission Date / Last Payment Received Date
          if (
            apiHeaders[index] === "t*Enquiry Date" ||
            apiHeaders[index] === "t*Last Payment Received Date"
          ) {
            if (!cell || cell === "-NA-") return "---";

            return formatDisplayDate(cell);
          }

          // Empty values
          if (cell === "" || cell === null || cell === undefined || cell === "-NA-") {
            return "---";
          }

          return cell;
        })
      );

      setHeaders(formattedHeaders);
      setReportDashboardData(transformedRows);

      clearTimeout(slowLoadingTimer);
      setIsLoading(false);
      setNoTimeSet(false);
      setIsMessageBoxVisible(false);
    } catch (error) {
      clearTimeout(slowLoadingTimer);
      setIsLoading(false);
      setNoTimeSet(false);
      setIsMessageBoxVisible(true);

      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span style={{ marginLeft: "10px", marginTop: "3px" }}>
              Error: {error.message}
            </span>
          </div>
        </div>
      );

      console.error("Error fetching student fee plan dashboard:", error);
    }
  };

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "37px",
        marginBottom: "40px",
      }}
    >
      <div>
        <div
          style={{
            backgroundColor: "white",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            zIndex: 1001,
            top: 0,
          }}
        >
          <p style={{ color: "#2F2E40", fontSize: "30px" }}>
            Fee Plan Dashboard
          </p>
          <div style={{ display: "flex" }}>
            <button
              style={{
                padding: "12px",
                marginRight: "18px",
                width: "150px",
                boxShadow: "0px 4px 4px 0px #00000040",
                marginTop: "0",
                opacity: isLoading ? 0.6 : 1,
                cursor: isLoading ? "not-allowed" : "pointer",
                display: "none", // hidden for now - functionality kept, not removed
              }}
              className="create-test-section-btn"
              onClick={() => {
                if (!isLoading) navigate("/new_fee_plan");
              }}
              disabled={isLoading}
            >
              <span className="plus-icon-create">+</span> NEW FEE PLAN
            </button>
          </div>
        </div>
        <p style={{ marginTop: "1%", color: "#2F2E40" }}>         
          Using this dashboard fee plan of student's of the current and previous sessions can be created and edited.
        </p>
        <div>
          <FeePlanStatusTable
            headers={headers}
            data={reportDashboardData}
            searchPlaceholder="Search students..."
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            bulk={false}
          />
        </div>
      </div>
    </div>
  );
};

export default FeePlanStatusDashboard;